import { configureStore } from '@reduxjs/toolkit'
import { persistReducer, persistStore } from "redux-persist";
//导入需要配置的数据源，可以选择，storage，cookie,session等
import storage from "redux-persist/lib/storage";
import rootReducer from './reducer/rootReducer';


//定义配置的信息
const persitConfig = {
    key:"root",
    storage:storage
}

const persistReducers = persistReducer(persitConfig,rootReducer);


const store = configureStore({
	reducer:persistReducers,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck: false,}),
});
const persistor =  persistStore(store);
 
export { store, persistor };

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch